export const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50];

export const VALID_UNSELECTED_PROVIDER_ROUTES = ['SelectProvider', 'Settings', 'Booking'];
